import { client } from './client';
export function getOnboardingStatus() {
    return client.get('/onboarding');
}
export function markManagerTutorialSeen() {
    return client.patch('/onboarding', { seenManagerTutorial: true });
}
export function markEditorTutorialSeen() {
    return client.patch('/onboarding', { seenEditorTutorial: true });
}
export function resetOnboarding() {
    return client.post('/onboarding/reset', {});
}
